






























import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'LanguageDropdownSelect',

  data() {
    return {
      currentLocale: this.$i18n.locale,
      languageIcon: '',
      languages: [
        { label: 'English', value: 'en', icon: require('@/assets/svgs/EN.svg') },
        { label: 'Deutsch', value: 'de', icon: require('@/assets/svgs/DE.svg') },
        { label: 'Español', value: 'es', icon: require('@/assets/svgs/ES.svg') },
        { label: 'Français', value: 'fr', icon: require('@/assets/svgs/FR.svg') },
        { label: 'Italiano', value: 'it', icon: require('@/assets/svgs/IT.svg') },
        { label: 'Polski', value: 'pl', icon: require('@/assets/svgs/PL.svg') },
        { label: 'Pусский', value: 'ru', icon: require('@/assets/svgs/RU.svg') },
        { label: 'Português', value: 'pt', icon: require('@/assets/svgs/PT.svg') }
      ]
    }
  },
  computed: {
    ...mapGetters({
      defaultLanguage: 'defaultUserLanguage'
    })
  },
  created() {
    this.checkPreferredLanguage()
  },
  methods: {
    ...mapActions(['savePreferedLanguages']),
    async handleLanguageChange(language) {
      this.setLanguage(language)
      await this.savePreferedLanguages(language)
    },
    setLanguage(preferredLanguage) {
      this.$i18n.locale = preferredLanguage

      this.languageIcon = this.languages
        .filter(lang => lang.value === preferredLanguage)
        .map(selectedIcon => selectedIcon.icon)
    },
    checkPreferredLanguage() {
      /* if the user has a preferred language set that - otherwise use the current locale */
      const preferredLanguage = this.defaultLanguage

      preferredLanguage
        ? this.handleLanguageChange(preferredLanguage)
        : this.handleLanguageChange(this.currentLocale)
    }
  }
}
